// A low wooden fence panel that blocks passage. Ported 1:1 from age-of-mcp's
// fence.ts: a single post per build stage (the connection arms only appear when
// the game passes neighbour fences; this lone-tile render has none), with the
// shared foundationSlab for the foundation stage.
import * as THREE from "three";
import { defineModel, foundationSlab, type Part } from "../../lib";

const POST_COLOR = "#7a5a32";

const STAGE_H = [0, 0.18, 0.30, 0.42];
const POST_W = 0.07;

function partsFor(s: number): Part[] {
  if (s <= 0) return [foundationSlab(0.6, 0.04)];
  const h = STAGE_H[Math.min(s, 3)]!;
  if (h <= 0) return [];
  const postH = h + 0.04;
  return [
    { geometry: new THREE.BoxGeometry(POST_W, postH, POST_W),
      color: POST_COLOR, position: [0, postH / 2, 0] },
  ];
}

export const fence = defineModel({
  id: "fence",
  tiles: { w: 1, h: 1 },
  batchId: "standard",
  name: "Fence",
  tags: ["building","fence","low-poly","age-of-mcp","classic"],
  summary: "Low-poly fence.",
  description: "A low wooden fence panel that blocks passage.",
  author: "age-of-mcp",
  footprint: 0.8,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => partsFor(0) },
    { id: "stage-1", label: "Lower", parts: () => partsFor(1) },
    { id: "stage-2", label: "Upper", parts: () => partsFor(2) },
    { id: "complete", label: "Complete", parts: () => partsFor(3) },
  ],
  animations: [],
});
